Vue.mixin({
    computed: {
        darks() {
			let themedarks = {};
			if(this.$store && this.$store.getters.themedarksactive)
				themedarks = this.$store.getters.themedarksactive;
            return themedarks;
        },
        onGenericTrial() {
            return !this.$store.state.activePlan && this.spark.state.currentTeam && this.spark.state.currentTeam.trial_ends_at &&
                moment.utc(this.spark.state.currentTeam.trial_ends_at).isAfter(moment.utc());
        }
    },
    methods: {
        iCan(capability, group, team_id = Spark.state.user.current_team_id) {
            let able = false;
            if (!this.capabilityInPlan(group))
                return false;

            if (this.$store.state.capabilities[team_id] && this.$store.state.capabilities[team_id][group]){
                if(Array.isArray(capability)){
                    for (let x = 0, capabilityitem; capabilityitem = capability[x]; x++){
                        able = this.$store.state.capabilities[team_id][group][capabilityitem];
                        if(able)
                            break;
                    }
                }else{
                    able = this.$store.state.capabilities[team_id][group][capability];
                }
            }
            return able;
        },
        myExcludes(group, team_id = Spark.state.user.current_team_id) {
            let excludes = [];
            if (this.$store.state.capabilities[team_id] && this.$store.state.capabilities[team_id][group])
                excludes = this.$store.state.capabilities[team_id][group].excludes;
            return excludes;
        },
        capabilityInPlan(capability) {
            let activePlan = this.$store.state.activePlan;

            if (this.onGenericTrial)
                return true;
            if (!activePlan)
                return false;
            if (['Exports', 'Reports'].indexOf(capability) > -1) {
                return ['Standard', 'Pro'].indexOf(activePlan.name) > -1;
            }
            if (['Theming', '2 factor auth'].indexOf(capability) > -1) {
                return activePlan.name === 'Pro';
            }
            return true;
        }
    }
});

Vue.filter('date', value => {
    return moment(value).local().format('MMMM Do, YYYY')
});

Vue.filter('datetime', value => {
    return moment(value).local().format('MMMM Do, YYYY h:mm A');
});

Vue.filter('relative', value => {
    return moment(value).local().locale('en-short').fromNow();
});